import { type outputMonad } from '../../server/appRouter/shared/outputMonad';
import { notifications } from '@mantine/notifications';
import { BadgeAlert, BadgeCheck } from 'lucide-react';
import { type FieldValues, type UseFormReturn } from 'react-hook-form';
import { type z } from 'zod';

export const createSaveHandler = <T extends FieldValues>(
  form: UseFormReturn<T>,
  handler: (data: T) => Promise<z.infer<ReturnType<typeof outputMonad>>>,
  onSuccess: () => void,
) => {
  return form.handleSubmit(async (data) => {
    console.log(data);
    const result = await handler(data);
    if (!result.ok) {
      if (result.field && result.field in data) {
        // @ts-expect-error it's ok
        form.setError(result.field, { message: result.error });
      } else {
        notifications.show({
          message: (
            <>
              <BadgeAlert color="var(--color-red-400)" />
              Unable to save changes. {result.error}
            </>
          ),
        });
      }

      return;
    }

    onSuccess();
    notifications.show({
      message: (
        <>
          <BadgeCheck color="var(--color-lime-400)" /> Changes saved.
        </>
      ),
    });
  });
};
